import { useFilterConfig } from '../hooks/useFilterConfig';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function WorkflowTemplateFilterControls() {
  const {
    HUB_PLAN,
    OBJECTIVE
  } = useFilterConfig();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectFilter, {
      filter: HUB_PLAN
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: OBJECTIVE,
      multi: true
    })]
  });
}